export default __webpack_public_path__ + "static/media/cgmp-Products-3.6fb4c12a.jpg";